import { motion } from "framer-motion";
import { CountUp } from "./CountUp";

export function StatCard({
  icon: Icon,
  value,
  suffix,
  label,
  delay = 0,
  valueClassName = "text-foreground",
  immediate = false,
}: {
  icon?: React.ElementType;
  value: string;
  suffix: string;
  label: string;
  delay?: number;
  valueClassName?: string;
  immediate?: boolean;
}) {
  const motionProps = immediate
    ? { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 } }
    : {
        initial: { opacity: 0, y: 16 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: "-40px" as const },
      };

  return (
    <motion.div
      {...motionProps}
      transition={{ delay, duration: 0.5 }}
      className="rounded-2xl border border-primary/20 bg-[#0d1520] p-5 hover:border-primary/50 [@media(pointer:fine)]:hover:-translate-y-0.5 transition-[border-color,transform,box-shadow] duration-300"
      style={{ boxShadow: "0 0 0 1px rgba(19,216,170,0.1), 0 8px 24px rgba(0,0,0,0.4)" }}
    >
      <div className="flex items-center gap-4">
        {Icon && (
          <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-primary/10">
            <Icon size={20} className="text-primary opacity-80" strokeWidth={1.5} />
          </div>
        )}
        <div>
          <p className={`text-2xl font-display leading-none ${valueClassName}`}>
            <CountUp value={value} />
            <span className="text-lg text-primary">{suffix}</span>
          </p>
          <p className="text-[10px] font-mono font-semibold tracking-[0.15em] text-muted-foreground uppercase mt-1">
            {label}
          </p>
        </div>
      </div>
    </motion.div>
  );
}
